import React from "react";

const Relive = () => {
    return (
        <>
            <section class="relive-con position-relative">
                <figure class="relive-rightbottomimage mb-0">
                    <img src="./assets/images/relive-rightbottomimage.png" alt="image-0" class="img-fluid" />
                </figure>
                <div class="container position-relative">
                    <div class="row">
                        <div class="col-lg-6 col-md-12 col-sm-12 col-12 text-lg-left text-center order-lg-1 order-2">
                            <div class="relive_wrapper" data-aos="fade-up">
                                <figure class="relive-circle mb-0">
                                    <img src="./assets/images/relive-circle.png" alt="image-0" class="img-fluid" />
                                </figure>
                                <figure class="relive-doted mb-0">
                                    <img src="./assets/images/relive-doted.png" alt="image-0" class="img-fluid" />
                                </figure>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-12 col-sm-12 col-12 order-lg-2 order-1">
                            <div class="relive_content" data-aos="fade-up">
                                <h2>Spreading <span> Sweetnesss</span> Since Day One!</h2>
                                <p>From chewy caramel delights to rich chocolate truffles, explore our menu of classic candy creations.</p>
                                <a href="/about" class="text-decoration-none all_button">Unwrap Our Story<i
                                    class="fa-solid fa-arrow-right"></i></a>
                                <figure class="relive-triangle mb-0">
                                    <img src="./assets/images/relive-triangle.png" alt="image-0" class="img-fluid" />
                                </figure>
                            </div>
                        </div>
                    </div>
                    <figure class="relive-image mb-0 charac" data-aos="zoom-in">
                        <img src="https://res.cloudinary.com/dzk6ng1ba/image/upload/v1743059027/relive-image_1_1_ijmbow.png" alt="image-0" class="img-fluid" />
                    </figure>
                </div>
            </section>
        </>
    );
};

export default Relive;